import { useState } from "react";
import { AxiosRequest } from "_services/api";

export function useBaixarComprovante() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [baixando, setBaixando] = useState(false);

  const baixar = async (idLote: number, idProcesso: number) => {
    setBaixando(true);
    try {
      const { data, headers } = await msAw.get(
        `/financeiro/pagamento-taxa/lote/${idLote}/processos/${idProcesso}/comprovante`,
        { responseType: "blob" },
      );

      const contentType =
        headers?.["content-type"] || data?.type || "application/octet-stream";
      const url = window.URL.createObjectURL(
        new Blob([data], { type: contentType }),
      );
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = headers?.["content-disposition"] ?? "";
      const match = /filename="?([^"]+)"?/.exec(contentDisposition);
      const extensao = contentType.includes("pdf")
        ? ".pdf"
        : contentType.includes("png")
          ? ".png"
          : /jpe?g/.test(contentType)
            ? ".jpg"
            : "";
      link.download = match?.[1] ?? `comprovante-${idProcesso}${extensao}`;

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      setBaixando(false);
    }
  };

  return { baixando, baixar };
}
